var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"WhereStayDetail"}},[(!_vm.poiContent)?_c('LogoLoading'):_c('div',[_c('PoiDetail',{attrs:{"poiDetail":_vm.poiContent}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }